var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"orgStrut"}},[_c('bread',{attrs:{"content":_vm.breadContent}}),_c('p',{staticClass:"Page-title"},[_vm._v("组织架构")]),_c('el-divider'),_c('img',{staticClass:"image",attrs:{"src":_vm.imgSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }